import { ThemeUICSSObject } from '@apia/theme';
import { responsive } from '../../../util';
/* IMPORT HERE */

export const collector: ThemeUICSSObject = {
  /* PREPEND HERE */
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: '1 !important',
    minWidth: 'min(400px, calc(100vw - 52px))',
    overflow: 'hidden',
    pr: 2,

    'h1, h2, h3, h4, h5, h6, .separator': {
      py: 5,
    },

    '.collector__fields': {
      overflow: 'auto',
      gap: '8px',
      display: 'flex',
      flexDirection: 'column',

      '& > *:first-child': {
        '& h1, h2, h3, h4, h5, h6, .separator': {
          pt: 0,
        },
      },
    },

    '.autogrow_textarea': {
      maxHeight: '20vh',
      width: '100%',
      border: '1px solid',
      borderColor: 'palette.border.field',
      borderRadius: 'default',
      padding: responsive({ 0: 3, 3: 4 }),
    },

    '.collector__buttons': {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'end',
      gap: 4,
    },

    '.fieldWrapper.checkbox': {
      display: 'flex',
      flexDirection: 'row-reverse',
      gap: 4,
      alignItems: 'start',
      justifyContent: 'start',
    },

    '.switch .fieldWrapper.checkbox': {
      alignItems: 'center',
    },

    '.validationsForm': {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      overflow: 'hidden',
    },

    ':disabled': {
      backgroundColor: 'form.fields.disabled.backgroundColor',
    },
  },

  modal: {
    '.modal__main': {},
  },
};
